import { CommonModule } from '@angular/common';
import { Component, effect, inject, input, output, signal, type InputSignal, type OutputEmitterRef, type SimpleChanges, type WritableSignal } from '@angular/core';
import type { Payment } from '../../../interfaces/payment';
import {Order, PageControl, TableColumn} from '../../../interfaces/application';
import { PaymentService } from '../../../services/payment.service';
import { finalize } from 'rxjs';
import { TableModule } from 'primeng/table';

@Component({
  selector: 'app-table-payments-top-five',
  imports: [
    CommonModule,
    TableModule,
  ],
  templateUrl: './table-payments-top-five.html',
  styleUrl: './table-payments-top-five.css'
})
export class TablePaymentsTopFive {

  private readonly _paymentService: PaymentService = inject(PaymentService);

  public localLoading: WritableSignal<boolean> = signal<boolean>(false);
  public loading: InputSignal<boolean> = input<boolean>(false);
  public search_term: InputSignal<string> = input<string>('');

  public edit: OutputEmitterRef<Payment> = output<Payment>();

  public items: Payment[] = [];

  public columns: TableColumn[] = [
    {
      label: 'Categoria',
      slug: 'category',
      align: 'text-start',
      sortable: false,
    },
    {
      label: 'Valor',
      slug: 'value',
      align: 'text-start',
      sortable: false,
    },
    {
      label: 'Fornecedor',
      slug: 'receiver',
      align: 'text-start',
      sortable: false,
    },
    {
      label: 'Vencimento',
      slug: 'due_date',
      align: 'text-start',
      sortable: false,
    },
  ];

  public ngOnChanges(changes: SimpleChanges): void {
    const {
      loading,
    } = changes;

    if (loading?.previousValue !== null && !loading?.currentValue) {
      this.loadData();
    }
  }

  public loadData(): void {

    const filters = {
      search_term: this.search_term() || '',
    };

    this.localLoading.set(true);
    this._paymentService.topFive(filters)
      .pipe(finalize(() => this.localLoading.set(false)))
      .subscribe({
        next: response => {
          this.items = response.data;
        }
      })
  }
}
